// To be removed once Feature Flagging tool has been implemented
export const DEV_ENV = 'DEV'
export const TEST_ENV = 'TEST'
export const PREPROD_ENV = 'PREPROD'
export const PROD_ENV = 'PROD'
